import { render, staticRenderFns } from "./SvgBlocks.vue?vue&type=template&id=750dcb53&"
import script from "./SvgBlocks.vue?vue&type=script&lang=js&"
export * from "./SvgBlocks.vue?vue&type=script&lang=js&"
import style0 from "./SvgBlocks.vue?vue&type=style&index=0&id=750dcb53&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports